"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.advancedSelectStyling = void 0;
const colorDefinitions_1 = require("../../definitions/colorDefinitions");
const primary_color_definitions_1 = require("../../definitions/primary-color-definitions");
exports.advancedSelectStyling = {
    control: (provided, state) => {
        return {
            '&:active': {
                backgroundColor: primary_color_definitions_1.primaryColors.secGreen2Light,
                borderBottom: `2px solid ${primary_color_definitions_1.primaryColors.primaryGreen}`,
                color: colorDefinitions_1.colorDefinitions.blue100primary,
            },
            '&:hover': {
                backgroundColor: primary_color_definitions_1.primaryColors.secGreen2Light,
                borderBottom: `2px solid ${primary_color_definitions_1.primaryColors.primaryGreen}`,
                color: colorDefinitions_1.colorDefinitions.blue100primary,
            },
            backgroundColor: state.isFocused ? primary_color_definitions_1.primaryColors.secGreen2Light : '#F5F5F5',
            borderBottom: state.isDisabled
                ? 'none'
                : state.isFocused
                    ? `2px solid ${primary_color_definitions_1.primaryColors.primaryGreen}`
                    : `2px solid ${colorDefinitions_1.colorDefinitions.blue100primary}`,
            boxShadow: 'none',
            color: colorDefinitions_1.colorDefinitions.blue100primary,
            display: 'inline-flex',
            fontSize: '1.1rem',
            fontWeight: 400,
            height: '46px',
            lineHeight: 1.5,
            padding: '0.5rem 0.5rem',
            width: '100%',
        };
    },
    indicatorsContainer: (provided, state) => {
        return Object.assign(Object.assign({}, provided), { width: '14px' });
    },
    input: (provided) => {
        return Object.assign(Object.assign({}, provided), { position: 'absolute' });
    },
    menu: (provided) => {
        return Object.assign(Object.assign({}, provided), { borderBottom: `2px solid ${primary_color_definitions_1.primaryColors.primaryGreen}`, borderRadius: '0' });
    },
    menuList: (provided) => {
        return Object.assign(Object.assign({}, provided), { borderRadius: '0', paddingBottom: '0', paddingTop: '0' });
    },
    option: (provided, state) => {
        return Object.assign(Object.assign({}, provided), { backgroundColor: state.isSelected ? primary_color_definitions_1.primaryColors.secGreenMedium : state.isFocused ? '#DAF2F2' : '#F5F5F5', color: state.isDisabled ? '#acacac' : colorDefinitions_1.colorDefinitions.blue100primary, display: 'block', fontSize: '1rem', fontWeight: 400, height: '2.5rem', lineHeight: '1.5rem', padding: '8px 16px', width: '100%' });
    },
    singleValue: (provided, state) => {
        return Object.assign(Object.assign({}, provided), { color: primary_color_definitions_1.primaryColors.blue100primary, opacity: state.isDisabled ? 0.5 : 1, transition: 'opacity 300ms', width: '100%' });
    },
};
//# sourceMappingURL=advancedSelectStyling.js.map